import React from 'react';
import styles from './Skeleton.module.scss';

const Skeleton = ({ width = '100%', height = 20, borderRadius = 6, style = {}, className = '' }) => {
  return (
    <div
      className={styles.skeleton + (className ? ' ' + className : '')}
      style={{ width, height, borderRadius, ...style }}
    />
  );
};

export default Skeleton; 